export default "__VITE_ASSET__CWKHs$Tx__"